import { App, PageBase } from 'frontend/common-imports'
import OrderItem from 'models/order-item'
import ModalAlert from 'frontend/sprinkles/modal-alert'

class AddToOrderButton {
  static bindEvents () {
    document.querySelectorAll('.add-to-order--button').forEach(el => {
      el.addEventListener('click', () => this.handleButtonClick(el))
    })
  }

  static async handleButtonClick (button) {
    const order = await App.currentOrder

    const { orderableId, orderableType } = button.dataset
    order.items.push(new OrderItem({ attrs: { orderableId, orderableType } }))
    try {
      await order.push()
    } catch (e) {
      ModalAlert({ body: 'Something went wrong, sorry.' })
      throw e
    }
    if (Object.keys(order.errors || {}).length > 0) {
      // TODO: modal
      alert(order.fullErrorMessages)
    } else {
      window.location = '/order'
    }
  }
}

export default class MysteriousCasePage extends PageBase {
  static async handleDOMReady () {
    AddToOrderButton.bindEvents()
  }
}

MysteriousCasePage.init()
